import { theme } from 'configs/styled';
import React from 'react';

export interface IBulletList {
  items: string[];
}

const BulletList: React.FC<IBulletList> = props => {
  const { items } = props;
  return (
    <ul>
      {items.map((item, index) => (
        <li key={`list_${index}`} style={{ color: theme.palettes.black85 }}>
          {item}
        </li>
      ))}
    </ul>
  );
};

export default BulletList;
